<template src="./Footer.html"></template>
<style scoped src="./Footer.scss" lang="scss"></style>
<script>
export default {};
</script>
